import { UserMetadata } from './user-metadata';
import { UserEmploymentDetails } from './useremploymentdetails';

export class User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  cnp: string;
  gender: string;
  companyId?: number;
  companyName: string;
  profilePicturePhotoUrl?: string;
  monthlyBudget?: number;
  monthlyBudgetTransport?: number;
  monthlyBudgetProfessionalDevelopment?: number;
  initialBudget?: number;
  initialBudgetTransport?: number;
  initialBudgetProfessionalDevelopment?: number;
  reservedAmount?: number;
  totalAmount?: number;
  totalAmountTransport?: number;
  totalAmountProfessionalDevelopment?: number;
  totalAmountCashback?: number;
  numberOfMealTickets?: number;
  numberOfVacationTickets?: number;
  numberOfCultureTickets?: number;
  numberOfGiftTickets?: number;
  companyTaxDistribution?: number;
  isDeleted?: boolean;
  lastLogin?: string;
  userMetadata?: UserMetadata;
  userEmploymentDetails?: UserEmploymentDetails;
  timeSpentOnPlatform?: number;
  balanceLoadDay?: number;
  taxExemption: boolean;
  isFederated: boolean;
}
